import { Suspense } from "react";
import UniversalLoading from "@/components/loading/UniversalLoading";
import PicassoDashboard from "@/components/dashboard/pages/DashboardPage";
import { usePicassoAuth } from "@/hooks/common/usePicassoAuth";

export const DashboardView = () => {
  const { userEmail, isAdmin } = usePicassoAuth();

  return (
    <Suspense
      fallback={
        <div className="overflow-y-hidden">
          <UniversalLoading 
            variant="dashboard" 
            message="Loading dashboard..." 
          />
        </div>
      }
    >
      <PicassoDashboard userEmail={userEmail} isAdmin={isAdmin} />
    </Suspense>
  );
};

export default DashboardView;
